import {
  fetchJsonData,
  postJsonDataBlankResponse,
} from '../../../global/data/service.js'
import { showAlertBanner } from '../../AlertBanner/index.js'
import { STATUS_ERROR } from '../../AlertBanner/Constants.js'
import {
  ERROR_MESSAGE_TITLE,
  ERROR_MESSAGE_TEXT,
} from '../Helpers/ErrorMessages.js'
import { getItemsInCart, removeFromCart } from '../../../global/cart.js'
import { updateCartCount } from '../../../global/_nav.js'

export async function getMutualFundLiterature(type, classes) {
  try {
    const url = `/service/funds/literature?classes=${classes}&type=${type}`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getRiaLiterature(classes) {
  try {
    const url = `/service/funds/literature?classes=${classes}&type=RIA`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getFundLiterature(classes) {
  try {
    const url = `/service/funds/literature?classes=${classes}`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: ERROR_MESSAGE_TEXT,
    })
  }
}

export function getCartOrderData() {
  try {
    return getItemsInCart()
  } catch (err) {
    // showAlertBanner({ status: STATUS_ERROR, title: ERROR_MESSAGE_TITLE, text: ERROR_MESSAGE_TEXT })
  }
}

export function deleteCartOrderItem(item) {
  try {
    removeFromCart(item)

    updateCartCount()

    return true
  } catch (err) {
    // showAlertBanner({ status: STATUS_ERROR, title: ERROR_MESSAGE_TITLE, text: ERROR_MESSAGE_TEXT })
  }
}

export function createEmail(from, toArray, subject, body) {
  let emailPayload = {
    type: 'email',
    data: {
      from: from,
      to: toArray,
      subject: subject,
      body: body,
    },
  }

  return emailPayload
}

export async function sendEmail(emailPayload) {
  try {
    const url = `/api/email`

    return await postJsonDataBlankResponse(url, emailPayload)
  } catch (err) {
    // showAlertBanner({ status: STATUS_ERROR, title: ERROR_MESSAGE_TITLE, text: ERROR_MESSAGE_TEXT })
  }
}

export function isProduction() {
  return (
    window.location &&
    window.location.hostname.indexOf('www.columbiathreadneedleus.com') >= 0
  )
}
